<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-carousel :interval="4000" type="card" height="600px">
        <el-carousel-item v-for="item in imagesbox" :key="item.id">
          <img :src="item.idView" class="image">
        </el-carousel-item>
      </el-carousel>
    </el-col>
  </el-row>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'Demo',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      imagesbox: [
       /*  {id:0,idView:require("../../static/img/big/冷冻站.png")},
        {id:1,idView:require("../../static/img/bg.png")},
        {id:2,idView:require("../../static/img/background.png")} */]
    }
  },
  computed: {

  },
  mounted() {

  },
  methods: {

  }
}
</script>
<style scoped>
.image {
  max-height: 100%;
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/visualization.vue